document.addEventListener('DOMContentLoaded', () => {
    function getSelectedVariantText() {
        const selectedOptions = [];
        document.querySelectorAll('.swatch[data-option-index]').forEach(swatch => {
            const selectedOption = swatch.querySelector('input[type=radio]:checked');
            if (selectedOption) {
                selectedOptions.push(selectedOption.value);
            }
        });
        return selectedOptions.length > 1 ? selectedOptions.join(' / ') : selectedOptions[0];
    }

    function calculateAndAppendUnitPrice() {
        const priceElement = document.querySelector('.vat__product .money');
        const unitPriceElement = document.querySelector('.vat__product__unit .money');
        const unitPriceContainer = document.querySelector('.vat__product__unit');

        const unitPriceDetails = document.querySelector('.unitpricedetails');
        const unitPriceDivs = unitPriceDetails.querySelectorAll('div');
        const unitPriceDict = {};

        unitPriceDivs.forEach(div => {
            const textContent = div.textContent.trim();
            const [unitName, unitPrice] = textContent.split(':').map(str => str.trim());
            unitPriceDict[unitName] = parseFloat(unitPrice) / 100;
        });

        if (priceElement && unitPriceElement) {
            const selectedVariantText = getSelectedVariantText();

            if (!selectedVariantText) {
                unitPriceContainer.style.display = 'none';
                return;
            }

            const unitPrice = unitPriceDict[selectedVariantText];

            if (!isNaN(unitPrice)) {
                unitPriceElement.textContent = `€${unitPrice.toFixed(2)}`;
                unitPriceContainer.style.display = 'block';
            } else {
                unitPriceContainer.style.display = 'none';
            }
        }
    }

    document.querySelectorAll('.swatch input[type=radio]').forEach(radio => {
        radio.addEventListener('change', () => {
            setTimeout(calculateAndAppendUnitPrice, 200);
        });
    });
});
